module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": _vm.title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "text-center",
    staticStyle: {
      "margin-bottom": "80px"
    }
  }, [_c('span', {
    staticClass: "control-panel"
  }, [_vm._v("Display: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterType),
      expression: "filterType"
    }],
    staticStyle: {
      "font-size": "13px",
      "font-weight": "900"
    },
    attrs: {
      "id": "filterType"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.changeFilter($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "current"
    }
  }, [_vm._v("CURRENT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "expired"
    }
  }, [_vm._v("EXPIRED")])]), _vm._v(" "), _c('span', {
    staticClass: "control-panel control-panel-spacer"
  }, [_vm._v("Sort by: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sort),
      expression: "sort"
    }],
    staticStyle: {
      "font-size": "13px",
      "font-weight": "900"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sort = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.changeSortBy($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "title"
    }
  }, [_vm._v("TITLE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "posted"
    }
  }, [_vm._v("POST DATE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "expired"
    }
  }, [_vm._v("EXPIRATION DATE")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.direction),
      expression: "direction"
    }],
    staticStyle: {
      "font-size": "13px",
      "font-weight": "900"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.direction = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.changeSortDirection($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "asc"
    }
  }, [_vm._v("ASC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "desc"
    }
  }, [_vm._v("DESC")])])]), _vm._v(" "), _c('span', {
    staticClass: "text-center"
  }, [_c('h4', [_vm._v(_vm._s(_vm.warning))])]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "grantFeed"
    }
  }, _vm._l((_vm.grants), function(grant) {
    return _c('li', [_c('div', {
      staticClass: "grant-news"
    }, [_c('router-link', {
      staticClass: "grant-title",
      attrs: {
        "to": grant.path
      }
    }, [_vm._v(_vm._s(grant.title) + "\n                     ")]), _vm._v(" "), _c('div', {
      staticClass: "grant-date"
    }, [(_vm.isItNew(grant.posted)) ? _c('span', [_c('span', {
      staticClass: "new"
    }, [_vm._v("NEW!")]), _vm._v(" | ")]) : _vm._e(), _vm._v("Posted: " + _vm._s(_vm._f("moment")(grant.posted)) + " |\n\n                       "), (_vm.checkExpire(grant.expired)) ? _c('span', {
      staticStyle: {
        "color": "red",
        "font-weight": "900"
      }
    }, [_vm._v(_vm._s(_vm._f("moment")(grant.expired)) + " (EXPIRED)")]) : _c('span', {
      staticClass: "grant-deadline"
    }, [_vm._v("Deadline: " + _vm._s(_vm._f("moment")(grant.expired)))])]), _vm._v(" "), _c('div', {
      staticClass: "grant-description",
      domProps: {
        "innerHTML": _vm._s(grant.description)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "grant-readmore"
    }, [_c('router-link', {
      staticClass: "read-more-news btn btn-secondary btn-sm\n                       btn-readmore",
      attrs: {
        "to": grant.path
      }
    }, [_vm._v("Read more >>\n                       ")])], 1)], 1)])
  }))])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7204a462"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Grants.vue
// module id = 384
// module chunks = 0